export const errorFallbackComponentsName = {
  init: 'Init',
  topBar: 'TopBar',
  casinoRoutes: 'CasinoRoutes',
  sideNavigation: 'SideNavigation',
  storeContextProvider: 'StoreContext.Provider'
}
